export default __webpack_public_path__ + "static/media/book.47357e4d.png";